export default "__VITE_ASSET__DtCst3jC__"